import { reqGet, reqPut, reqDelete, reqPost } from './axiosFun';

// 获取系统参数
export const sysParamGet = (params) => { return reqGet("/sys-param/detail") };

// 更新系统参数
export const sysParamUpdate = (params) => { return reqPut("/sys-param", params) };

// 参数检测
export const sysParamCheck = () => { return reqGet("/sys-param/check") };




// WEBPACK FOOTER //
// ./src/api/SysParam.js